"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PTTTable = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Typography = require("./Typography");

var _blox = require("../blox");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Table component with sortable columns and selectable rows
 * @param {Object} arg
 * @param {Object[]} arg.columns - table metadata for cell customization
 * @param {string} arg.columns.field - key to access data on the row
 * @param {string} arg.columns.headerName - column header text
 * @param {boolean} arg.columns.collapse - [Does not work when styles.fixedLayout is true] When true, column will only take as much space as it needs, or be evenly distributed. 
 * @param {string} arg.columns.align - header text alignment
 * @param {boolean} arg.columns.sortable - whether column can be sorted
 * @param {boolean} arg.columns.borderRight - cells will have a right border
 * @param {string | import('react').ReactElement | number} arg.columns.formatter - Data for that row will be passed to the formatter for custom cell display
 * @param {string} arg.columns.sortUp - key for sorting ASC
 * @param {string} arg.columns.sortDown - key for sorting DESC
 * @param {boolean} arg.columns.headerNoWrap - If true, prevents header text from wrapping
 * @param {string} arg.columns.width - Width of the column. Only works when style.fixedLayout is true.
 * @param {Object[]} arg.rows - table data
 * @param {boolean} [arg.isLoading] - show loading gif when table data is being fetched
 * @param {string} [arg.sort] - current sort key for table
 * @param {(sort: string) => void} [arg.onSort] - callback when sorting on a column is fired
 * @param {(id: string) => void} [arg.onRowClick] - callback when row is clicked
 * @param {boolean} [arg.checkboxes] - whether rows start with a checkbox
 * @param {Object} [arg.selectionData] - current rows with checked checkboxes
 * @param {(selectionData: Object) => void} [arg.onSelectionChange] - callback when checkboxes are selected or deselected
 * @param {Object} [arg.styles] - styles for table
 * @param {string} [arg.styles.header.backgroundColor] - background color for header
 * @param {string} [arg.styles.header.textColor] - text color for header
 * @param {string} [arg.styles.header.verticalPadding] - vertical padding for header cells
 * @param {string} [arg.styles.header.horizontalPadding] - horizontal padding for header cells
 * @param {string} [arg.styles.border] - border of the table
 * @param {string} [arg.styles.borderRadius] - border radius of the component
 * @param {boolean} [arg.styles.evenColored] - If true, even rows are colored. Otherwise, odd rows are colored.
 * @param {boolean} [arg.styles.noEvenOddColor] - If true, even/odd row coloration is disabled.
 * @param {boolean} [arg.styles.rowsHorizontalBorders] - If true, show horizontal borders between rows
 * @param {string} [arg.styles.textColor] - text color of the table
 * @param {string} [arg.styles.verticalPadding] - vertical padding of each cell
 * @param {string} [arg.styles.horizontalPadding] - horizontal padding of each cell
 * @param {string} [arg.styles.maxHeight] - max height of the table. If specified, the table header will be sticky on scroll.
 * @param {boolean} [arg.styles.checkboxRightBorder] - If true, the right border of the checkbox column will be shown.
 * @param {boolean} [arg.styles.fixedLayout] - If true, the table will have table-layout: fixed: All columns get the same width by default unless a width is specified.
 * @param {boolean} [arg.styles.rowsCheckboxesAlignedTop] - If true, the checkboxes in the rows will be aligned to the top of the row instead of middle.
 * @returns import('react').ReactElement
*/
var PTTTable = function PTTTable(_ref) {
  var _styles$header3, _styles$header4;

  var _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? [] : _ref$rows,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$sort = _ref.sort,
      sort = _ref$sort === void 0 ? '' : _ref$sort,
      onSort = _ref.onSort,
      onRowClick = _ref.onRowClick,
      _ref$checkboxes = _ref.checkboxes,
      checkboxes = _ref$checkboxes === void 0 ? false : _ref$checkboxes,
      selectionData = _ref.selectionData,
      onSelectionChange = _ref.onSelectionChange,
      _ref$headerBanners = _ref.headerBanners,
      headerBanners = _ref$headerBanners === void 0 ? [] : _ref$headerBanners,
      _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      _ref$noItemsMessage = _ref.noItemsMessage,
      noItemsMessage = _ref$noItemsMessage === void 0 ? 'No results found.' : _ref$noItemsMessage;

  var handleSort = function handleSort(column) {
    return function (e) {
      if (!isLoading && onSort) {
        var field = e.currentTarget.dataset.field;
        var currentSortedCol = columns.find(function (c) {
          return c.sortUp === sort || c.sortDown === sort;
        });

        if (currentSortedCol && field === (currentSortedCol === null || currentSortedCol === void 0 ? void 0 : currentSortedCol.field)) {
          var sortCol = sort === currentSortedCol.sortUp ? currentSortedCol.sortDown : currentSortedCol.sortUp;
          onSort(sortCol !== null && sortCol !== void 0 ? sortCol : column.sortUp);
        } else {
          onSort(column.sortUp);
        }
      }
    };
  };

  var handleRowClick = function handleRowClick(id) {
    return function () {
      if (onRowClick) {
        onRowClick(id);
      }
    };
  };

  var handleSelectAll = function handleSelectAll(e) {
    if (onSelectionChange) {
      onSelectionChange({
        all: e.target.checked,
        selectedIds: e.target.checked ? rows.map(function (r) {
          return r.id;
        }) : []
      });
    }
  };

  var handleSelectItem = function handleSelectItem(id) {
    return function (e) {
      if (onSelectionChange) {
        var selected = e.target.checked;

        if (selectionData !== null && selectionData !== void 0 && selectionData.all && !selected) {
          // Everything was selected and we deselect one: set the rest to selected
          onSelectionChange({
            all: false,
            selectedIds: rows.filter(function (r) {
              return r.id !== id;
            }).map(function (r) {
              return r.id;
            })
          });
        } else {
          var _selectionData$select, _selectionData$select2, _selectionData$select3;

          // Just update the item
          onSelectionChange({
            all: false,
            selectedIds: selected ? _toConsumableArray(Array.from(new Set([].concat(_toConsumableArray((_selectionData$select = selectionData === null || selectionData === void 0 ? void 0 : selectionData.selectedIds) !== null && _selectionData$select !== void 0 ? _selectionData$select : []), [id])))) : (_selectionData$select2 = selectionData === null || selectionData === void 0 ? void 0 : (_selectionData$select3 = selectionData.selectedIds) === null || _selectionData$select3 === void 0 ? void 0 : _selectionData$select3.filter(function (selectedId) {
              return selectedId !== id;
            })) !== null && _selectionData$select2 !== void 0 ? _selectionData$select2 : []
          });
        }
      }
    };
  }; // columns can also be react elements, if only text is passed there are default styles applied


  var headers = columns.map(function (column) {
    var _column$id, _styles$header, _styles$header2;

    var innerContent = /*#__PURE__*/_react["default"].createElement(_Typography.Text, {
      as: "span",
      $bold: true,
      $ws: column.headerNoWrap ? 'noWrap' : 'break-spaces'
    }, column.headerName);

    return /*#__PURE__*/_react["default"].createElement(TableHeader, {
      key: (_column$id = column.id) !== null && _column$id !== void 0 ? _column$id : column.field,
      className: column.collapse ? 'collapse' : '',
      textAlign: column.align,
      $verticalPadding: styles === null || styles === void 0 ? void 0 : (_styles$header = styles.header) === null || _styles$header === void 0 ? void 0 : _styles$header.verticalPadding,
      $horizontalPadding: styles === null || styles === void 0 ? void 0 : (_styles$header2 = styles.header) === null || _styles$header2 === void 0 ? void 0 : _styles$header2.horizontalPadding,
      onClick: column.sortable ? handleSort(column) : undefined,
      "data-field": column.field,
      $sortable: column.sortable,
      $width: styles.fixedLayout ? column.width : column.collapse ? 'collapse' : 'auto'
    }, /*#__PURE__*/_react["default"].createElement(HeaderContent, {
      $noWrap: !!column.headerNoWrap
    }, column.headerTooltip ? /*#__PURE__*/_react["default"].createElement(HeaderTooltip, {
      $noWrap: !!column.headerNoWrap,
      position: "fixed",
      content: column.headerTooltip
    }, innerContent) : innerContent, column.sortable && sort && [column.sortUp, column.sortDown].includes(sort) ?
    /*#__PURE__*/
    // Show the chevron only if sorted
    _react["default"].createElement("i", {
      className: "chevron fas ".concat(sort === column.sortUp ? 'fa-chevron-up' : 'fa-chevron-down')
    }) : null));
  });
  var showCheckboxHeader = checkboxes && rows.length > 0;
  return /*#__PURE__*/_react["default"].createElement(ScrollContainer, {
    $border: styles === null || styles === void 0 ? void 0 : styles.border,
    $br: styles === null || styles === void 0 ? void 0 : styles.borderRadius,
    $maxHeight: styles === null || styles === void 0 ? void 0 : styles.maxHeight,
    $horizontalScroll: !styles.fixedLayout
  }, /*#__PURE__*/_react["default"].createElement(StyledTable, {
    $textColor: styles === null || styles === void 0 ? void 0 : styles.textColor,
    $checkboxRightBorder: !!(styles !== null && styles !== void 0 && styles.checkboxRightBorder),
    $fixedLayout: !!styles.fixedLayout
  }, /*#__PURE__*/_react["default"].createElement(THead, {
    $bg: styles === null || styles === void 0 ? void 0 : (_styles$header3 = styles.header) === null || _styles$header3 === void 0 ? void 0 : _styles$header3.backgroundColor,
    $c: styles === null || styles === void 0 ? void 0 : (_styles$header4 = styles.header) === null || _styles$header4 === void 0 ? void 0 : _styles$header4.textColor,
    $sticky: !!styles.maxHeight
  }, /*#__PURE__*/_react["default"].createElement("tr", null, showCheckboxHeader ? /*#__PURE__*/_react["default"].createElement(CheckboxCell, {
    as: "th",
    $width: styles.fixedLayout ? 'fixed' : 'auto'
  }, /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
    className: "blox table",
    type: "checkbox",
    checked: !!(selectionData !== null && selectionData !== void 0 && selectionData.all),
    onChange: handleSelectAll
  })) : null, headers), headerBanners.map(function (hb, index) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(Banner, {
      colSpan: columns.length + (showCheckboxHeader ? 1 : 0)
    }, hb));
  })), /*#__PURE__*/_react["default"].createElement("tbody", null, isLoading || rows.length === 0 ? /*#__PURE__*/_react["default"].createElement(TableRow, {
    $evenColored: styles.evenColored,
    $noEvenOddColor: styles.noEvenOddColor,
    $rowsHorizontalBorders: styles.rowsHorizontalBorders
  }, /*#__PURE__*/_react["default"].createElement("td", {
    colSpan: columns.length
  }, isLoading ? /*#__PURE__*/_react["default"].createElement(LoadingResults, null) : /*#__PURE__*/_react["default"].createElement(_Typography.Text, {
    $h: 60,
    $lh: 60,
    $textAlign: "center",
    $c: "var(--blox-slate3)",
    $fs: 14
  }, noItemsMessage))) : null, !isLoading && rows.length ? rows.map(function (r) {
    var _selectionData$select4;

    return /*#__PURE__*/_react["default"].createElement(TableRow, {
      key: r.id,
      onClick: handleRowClick(r.id),
      $clickable: !!onRowClick,
      $evenColored: styles.evenColored,
      $noEvenOddColor: styles.noEvenOddColor,
      $rowsHorizontalBorders: styles.rowsHorizontalBorders
    }, checkboxes ? /*#__PURE__*/_react["default"].createElement(CheckboxCell, null, /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
      className: "blox table",
      type: "checkbox",
      checked: !!(selectionData !== null && selectionData !== void 0 && selectionData.all || selectionData !== null && selectionData !== void 0 && (_selectionData$select4 = selectionData.selectedIds) !== null && _selectionData$select4 !== void 0 && _selectionData$select4.includes(r.id)),
      onChange: handleSelectItem(r.id),
      $alignedTop: !!(styles !== null && styles !== void 0 && styles.rowsCheckboxesAlignedTop)
    })) : null, columns.map(function (c) {
      var _c$id;

      return /*#__PURE__*/_react["default"].createElement(TableData, {
        key: "".concat(r.id, "-").concat((_c$id = c.id) !== null && _c$id !== void 0 ? _c$id : c.field),
        textAlign: c.align,
        borderRight: c.borderRight,
        className: c.collapse ? 'collapse' : '',
        $verticalPadding: styles === null || styles === void 0 ? void 0 : styles.verticalPadding,
        $horizontalPadding: styles === null || styles === void 0 ? void 0 : styles.horizontalPadding
      }, typeof c.formatter === 'function' ? c.formatter(r[c.field], r) : r[c.field]);
    }));
  }) : null)));
};

exports.PTTTable = PTTTable;

var ScrollContainer = _styledComponents["default"].div.withConfig({
  displayName: "PTTTable__ScrollContainer",
  componentId: "sc-ayxgww-0"
})(["max-height:", ";overflow:", ";border:", ";border-radius:", ";position:relative;"], function (props) {
  return props.$maxHeight;
}, function (props) {
  return props.$maxHeight || props.$horizontalScroll ? 'auto' : '';
}, function (props) {
  var _props$$border;

  return (_props$$border = props.$border) !== null && _props$$border !== void 0 ? _props$$border : 'none';
}, function (props) {
  var _props$$br;

  return (_props$$br = props.$br) !== null && _props$$br !== void 0 ? _props$$br : '0';
});

var Banner = _styledComponents["default"].td.withConfig({
  displayName: "PTTTable__Banner",
  componentId: "sc-ayxgww-1"
})(["padding:0;background:var(--blox-slate0a);"]);

var THead = _styledComponents["default"].thead.withConfig({
  displayName: "PTTTable__THead",
  componentId: "sc-ayxgww-2"
})(["background-color:", ";color:", ";padding-right:15px;", ""], function (props) {
  var _props$$bg;

  return (_props$$bg = props.$bg) !== null && _props$$bg !== void 0 ? _props$$bg : 'white';
}, function (props) {
  return props.$c;
}, function (props) {
  return props.$sticky && "\n            position: sticky;\n            top: 0;\n            z-index: 1;\n        ";
});

var CellBase = (0, _styledComponents.css)(["vertical-align:middle;"]);

var CheckboxCell = _styledComponents["default"].td.withConfig({
  displayName: "PTTTable__CheckboxCell",
  componentId: "sc-ayxgww-3"
})(["  padding:0;position:relative;width:", ";&:before{content:' ';width:55px;display:block;}"], function (props) {
  return props.$width === 'auto' ? '0.001%' : '50px';
});

var StyledCheckbox = _styledComponents["default"].input.withConfig({
  displayName: "PTTTable__StyledCheckbox",
  componentId: "sc-ayxgww-4"
})(["position:absolute;top:", ";left:0;margin:0;", ""], function (props) {
  return props.$alignedTop ? '10px' : '0';
}, function (props) {
  return props.$alignedTop ? 'height: auto !important' : '';
});

var StyledTable = _styledComponents["default"].table.withConfig({
  displayName: "PTTTable__StyledTable",
  componentId: "sc-ayxgww-5"
})(["background-color:white;border-collapse:collapse;margin:0;padding:0;width:100%;font-family:'sofia-pro',sans-serif;font-size:14px;color:", ";table-layout:", ";& ", "{border-right:", ";}"], function (props) {
  var _props$$textColor;

  return (_props$$textColor = props.$textColor) !== null && _props$$textColor !== void 0 ? _props$$textColor : 'var(--blox-slate3)';
}, function (props) {
  return props.$fixedLayout ? 'fixed' : 'auto';
}, CheckboxCell, function (_ref2) {
  var $checkboxRightBorder = _ref2.$checkboxRightBorder;
  return $checkboxRightBorder ? '1px solid var(--blox-slate1c)' : 'none';
});

var TableRow = _styledComponents["default"].tr.withConfig({
  displayName: "PTTTable__TableRow",
  componentId: "sc-ayxgww-6"
})(["background-color:white;", " ", " ", ""], function (props) {
  return props.$noEvenOddColor ? '' : (0, _styledComponents.css)(["&:nth-of-type(", "){background-color:var(--blox-slate0a);}"], props.$evenColored ? 'even' : 'odd');
}, function (props) {
  return props.$rowsHorizontalBorders ? (0, _styledComponents.css)(["border-top:1px solid var(--blox-slate1c);"]) : '';
}, function (_ref3) {
  var $clickable = _ref3.$clickable;
  return $clickable && (0, _styledComponents.css)(["cursor:pointer;"]);
});

var TableData = _styledComponents["default"].td.withConfig({
  displayName: "PTTTable__TableData",
  componentId: "sc-ayxgww-7"
})(["", " padding:", " ", ";text-align:", ";border-right:", ";&.collapse{white-space:nowrap;}"], CellBase, function (props) {
  var _props$$verticalPaddi;

  return (_props$$verticalPaddi = props.$verticalPadding) !== null && _props$$verticalPaddi !== void 0 ? _props$$verticalPaddi : '15px';
}, function (props) {
  var _props$$horizontalPad;

  return (_props$$horizontalPad = props.$horizontalPadding) !== null && _props$$horizontalPad !== void 0 ? _props$$horizontalPad : '20px';
}, function (_ref4) {
  var _ref4$textAlign = _ref4.textAlign,
      textAlign = _ref4$textAlign === void 0 ? 'left' : _ref4$textAlign;
  return textAlign;
}, function (_ref5) {
  var _ref5$borderRight = _ref5.borderRight,
      borderRight = _ref5$borderRight === void 0 ? false : _ref5$borderRight;
  return borderRight ? '1px solid var(--blox-slate1a)' : 'none';
});

var TableHeader = _styledComponents["default"].th.withConfig({
  displayName: "PTTTable__TableHeader",
  componentId: "sc-ayxgww-8"
})(["", " padding:", " ", ";box-sizing:border-box;position:relative;vertical-align:middle;text-overflow:ellipsis;text-align:", ";", " width:", ";"], CellBase, function (props) {
  var _props$$verticalPaddi2;

  return (_props$$verticalPaddi2 = props.$verticalPadding) !== null && _props$$verticalPaddi2 !== void 0 ? _props$$verticalPaddi2 : '10px';
}, function (props) {
  var _props$$horizontalPad2;

  return (_props$$horizontalPad2 = props.$horizontalPadding) !== null && _props$$horizontalPad2 !== void 0 ? _props$$horizontalPad2 : '20px';
}, function (_ref6) {
  var _ref6$textAlign = _ref6.textAlign,
      textAlign = _ref6$textAlign === void 0 ? 'left' : _ref6$textAlign;
  return textAlign;
}, function (_ref7) {
  var $sortable = _ref7.$sortable;
  return $sortable ? "\n        cursor: pointer;\n    " : '';
}, function (props) {
  if (props.$width === 'auto') {
    return '1%'; // In table-layout:auto; this will make cells grow equaly
  } else if (props.$width === 'collapse') {
    /* "collapsed" cells should be as small as possible (fit to content) */

    /* Source -> react-table: https://github.com/TanStack/table/blob/a8f132505a9947b75f6eacdac9f858f529e863cb/old-examples/full-width-table/src/App.js#L41-L47 */

    /* Not using 0.0000000001% as it doesn't work in Firefox */
    return '0.001%;';
  } else {
    return props.$width;
  }
});

var LoadingResults = _styledComponents["default"].div.withConfig({
  displayName: "PTTTable__LoadingResults",
  componentId: "sc-ayxgww-9"
})(["height:60px;background-position:center center;background-repeat:no-repeat;background-size:35px 8px;background-image:url('https://assets.pxlecdn.com/blox/loader.gif');"]);

var HeaderContent = _styledComponents["default"].div.withConfig({
  displayName: "PTTTable__HeaderContent",
  componentId: "sc-ayxgww-10"
})(["position:relative;font-weight:var(--blox-font-weight-700);span{display:inline-block;overflow:hidden;text-overflow:ellipsis;max-width:100%;}.chevron{color:var(--blox-blue);margin-left:10px;cursor:pointer;position:absolute;top:50%;transform:translateY(-50%);}"]);

var HeaderTooltip = (0, _styledComponents["default"])(_blox.BloxTooltip).withConfig({
  displayName: "PTTTable__HeaderTooltip",
  componentId: "sc-ayxgww-11"
})(["display:inline-block;max-width:100%;"]);